export const ALERTS_NOTIFICATION_VIEWED = 'Alerts - Notification viewed'
